import { useEffect, useState } from "react";
import { api, slDateTime } from "@/lib/api";
import Timeline from "@/components/Timeline";

export function GuestTimeline({ slug, title }) {
  const [sections, setSections] = useState(null);
  useEffect(() => {
    const load = () => api.get(`/public/w/${slug}/timeline`).then((r) => setSections(r.data.sections)).catch(() => setSections([]));
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, [slug]);
  if (!sections) return <p className="text-center text-[#6C6560] py-10">Nalaganje …</p>;
  return <Timeline sections={sections} title={title} />;
}

export function VoiceList({ slug, title }) {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get(`/public/w/${slug}/voice`).then((r) => setItems(r.data)).catch(() => setItems([])); }, [slug]);
  if (!items) return null;
  return (
    <section className="max-w-2xl mx-auto space-y-4" data-testid="voice-public-list">
      <div className="text-center"><h2 className="font-display text-3xl sm:text-4xl font-light">{title}</h2><p className="text-[#6C6560] mt-2">Poslušajta želje in čestitke svojih najdražjih.</p></div>
      {items.length === 0 && <p className="text-center text-[#6C6560] py-8">Še ni glasovnih sporočil.</p>}
      {items.map((v) => (
        <article key={v.id} className="card-lux p-5 space-y-3" data-testid="voice-public-item">
          <div className="flex justify-between text-sm"><b>{v.guest_name}</b><span className="text-[#968E87]">{slDateTime(v.created_at)} · {Math.round(v.duration)} s</span></div>
          <audio src={`${process.env.REACT_APP_BACKEND_URL}${v.play_url}`} controls preload="none" className="w-full" />
        </article>
      ))}
    </section>
  );
}
